import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {HasContactBaseMixin} from "../../widget/mixins/HasContactBaseMixin.jsx";
import UserEditorBase from "./UserEditorBase.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";

// Todo: it should have permissions
export default class UserContactTab extends HasContactBaseMixin(UserEditorBase) {
  static get $name() {
    return "UserContactTab";
  }

  static get type() {
    return "usercontacttab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.userEditorContactGridState;
  }

  get recordType() {
    return "userId";
  }

  getStoreData() {
    return this.record.contacts;
  }

  getStore() {
    return this.project.userContactsStore;
  }

  getEntityStoreKey() {
    return STORE_KEYS.boardUserStore;
  }

  onTabChangeHandler({activeItem}) {
    // we need this logic in here because when a new user is added then the contacts tab should display contact that is coming from backend response.
    if (activeItem.type === this.type) {
      this.loadData();
    }
  }
}

UserContactTab.initClass();
